import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const LeadershipTeam = ({ leaders }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Leadership Team</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {leaders?.map((leader) => (
          <div key={leader?.id} className="bg-muted/50 border border-border rounded-lg overflow-hidden hover:border-primary/50 transition-smooth">
            <div className="aspect-square overflow-hidden">
              <Image
                src={leader?.image}
                alt={leader?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="text-lg font-semibold text-foreground mb-1">{leader?.name}</h3>
              <p className="text-sm text-primary font-medium mb-3">{leader?.position}</p>
              <p className="text-sm text-muted-foreground mb-4 line-clamp-3">{leader?.bio}</p>
              <div className="flex items-center gap-3">
                {leader?.linkedin && (
                  <a
                    href={leader?.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                  >
                    <Icon name="Linkedin" size={16} className="text-primary" />
                  </a>
                )}
                {leader?.twitter && (
                  <a
                    href={leader?.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center hover:bg-primary/20 transition-smooth"
                  >
                    <Icon name="Twitter" size={16} className="text-primary" />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeadershipTeam;